import React, { useEffect, useState } from "react";
import back from "../../assets/back.svg";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import InputField from "../../components/form/inputField/inputField";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { AdminButton } from "../../components/buttons/versionHistoryBtn";
import ErrorMsg from "../../components/form/errorMsg";
import {
  fetchRoleList,
  permissionsList,
  superUserDetails,
  updateSuperUser,
} from "../../redux/actions/superUserAction";
import { useDispatch } from "react-redux";
import { fetchDivisionList } from "../../redux/actions/commonActions";
import { vendorDivisionList } from "../../redux/actions/productActions";
import ChangeSaved from "../../components/popups/ChangeSaved";
import InputCapitalField from "../../components/form/inputField/inputCapitalField";
import LoadingSpinnerTable from "../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import ErrorPopup from "../../components/popups/ErrorPopup";

const SuperUserEdit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [superUserData, setSuperUserData] = useState(null);
  const [permission, setPermission] = useState([]);
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [edited, setEdited] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");

  console.log(superUserData);

  const phoneRegex = /^([+]\d{2})?\d{10}$/;

  useEffect(() => {
    setLoading(true);
    dispatch(
      superUserDetails(params?.id, fetchDetailSuccess, fetchDetailError)
    );
    dispatch(fetchRoleList(fetchPermissionSuccess, fetchPermissionError));
    dispatch(vendorDivisionList(fetchDivisionSuccess, fetchDivisionError));
  }, []);

  const fetchDetailSuccess = (data) => {
    setLoading(false);
    setSuperUserData(data.data.data);
    console.log("permissoin", data?.data?.data);
  };

  const fetchDetailError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const fetchPermissionSuccess = (data) => {
    console.log("permissions", data);
    setPermission(data);
  };

  const fetchPermissionError = (data) => {
    console.log(data);
  };

  const fetchDivisionSuccess = (data) => {
    console.log("eee", data);
    setDivisionOptions(data);
  };

  const fetchDivisionError = (err) => {
    console.log(err);
  };

  const initialValues = {
    super_user_id: superUserData?.id,
    employee_id: superUserData?.employee_id,
    name: superUserData?.name,
    email: superUserData?.email,
    mobile: superUserData?.mobile,
    divisions: superUserData?.superUserDivisions?.map(
      (ele) => ele?.vendorDivision?.id
    ),
    role_id: superUserData?.role_id,
  };
  const validationSchema = Yup.object().shape({
    employee_id: Yup.string().required("Required"),
    name: Yup.string().required("Required"),
    email: Yup.string().email("Not a proper email").required("Required"),
    mobile: Yup.string()
      .matches(phoneRegex, "Not a valid Number")
      .required("Required"),
    divisions: Yup.array().min(1, "At least one should be selected"),
    role_id: Yup.string().required("Required"),
  });

  const resetFunc = (setFieldValue) => {
    setFieldValue("employee_id", superUserData?.employee_id);
    setFieldValue("name", superUserData?.name);
    setFieldValue("email", superUserData?.email);
    setFieldValue("mobile", superUserData?.mobile);
    setFieldValue(
      "divisions",
      superUserData?.superUserDivisions?.map((ele) => ele?.vendorDivision?.id)
    );
    setFieldValue("role_id", superUserData?.role_id);
  };

  const onSubmit = (values) => {
    console.log(values);
    dispatch(updateSuperUser(values, onSuccess, onError));
  };

  const onSuccess = (data) => {
    console.log(data);
    setEdited(true);

    const timeOutFnc = () => {
      setEdited(false);
      navigate("/super-user/user");
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const modified_str = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(modified_str);
  };

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/super-user/user",
      breadcrumb: " / super users",
    },

    {
      path: "/super-user/user/edit/:id",
      breadcrumb: superUserData?.employee_id
        ? ` / ${superUserData?.employee_id} - edit`
        : " / edit",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              enableReinitialize={true}
              onSubmit={onSubmit}
            >
              {({ setFieldValue, values }) => (
                <Form className="">
                  <div className="search-container d-flex justify-content-between align-items-center">
                    <div
                      className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                      onClick={() => navigate(-1)}
                    >
                      <img src={back} alt="back_btn" />
                      <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                        BACK
                      </span>
                    </div>
                    <div className="d-flex justify-content-between m-1 mb-2">
                      <AdminButton
                        background="#E7E5FF"
                        width="100px"
                        type="button"
                        onClick={() => resetFunc(setFieldValue)}
                      >
                        RESET
                      </AdminButton>
                      <AdminButton
                        background="#2AD3E7"
                        color="white"
                        width="100px"
                        type="submit"
                      >
                        <span className="m-2">SAVE</span>
                      </AdminButton>
                    </div>
                  </div>
                  <div style={{ position: "relative" }}>
                    {loading == true ? (
                      <div className="list-spinner-container">
                        <LoadingSpinnerTable />
                      </div>
                    ) : (
                      <div className="scrolling">
                        <div className="form-width ms-4 ps-3 py-1">
                          <div className="mt-4 mb-1">
                            <InputField
                              id={"employee_id"}
                              label={"Company Employee ID"}
                              type={"text"}
                              placeholder={"Enter employee id"}
                              name={"employee_id"}
                              value={values?.employee_id}
                            />
                          </div>
                          <div className="my-1">
                            <InputCapitalField
                              setFieldValue={setFieldValue}
                              id={"name"}
                              label={"Name"}
                              type={"text"}
                              placeholder={"Enter name"}
                              name={"name"}
                              value={values?.name}
                            />
                          </div>
                          <div className="my-1">
                            <label className="Neutral_Color fw_400 fs_14 my-1">
                              Role
                            </label>
                            <Field>
                              {({ field }) => (
                                <Select
                                  {...field}
                                  options={permission}
                                  styles={customStyles}
                                  placeholder={"Enter role"}
                                  value={permission.filter(
                                    (s) => s.value == values.role_id
                                  )}
                                  onChange={(selected) => {
                                    setFieldValue("role_id", selected?.value);
                                  }}
                                />
                              )}
                            </Field>

                            <ErrorMsg name={"divisions"} />
                          </div>
                          <div className="my-1">
                            <InputField
                              id={"email"}
                              label={"Email Address"}
                              type={"text"}
                              placeholder={"Enter email address"}
                              name={"email"}
                              value={values?.email}
                            />
                          </div>
                          <div className="my-1">
                            <InputField
                              maxLength="10"
                              id={"mobile"}
                              label={"Phone Number"}
                              labelColor={"color_262c3d"}
                              type={"text"}
                              placeholder={"Enter phone number"}
                              name={"mobile"}
                              value={values?.mobile}
                            />
                          </div>
                          <div className="my-1">
                            <label className="Neutral_Color fw_400 fs_14 my-1">
                              Divisions Name
                            </label>
                            <Field>
                              {({ form, Field }) => (
                                <Select
                                  isMulti
                                  options={divisionOptions}
                                  styles={customStyles2}
                                  {...Field}
                                  id="divisions"
                                  placeholder="Search and select divisions"
                                  value={divisionOptions.filter((o1) =>
                                    values?.divisions?.some(
                                      (o2) => o2 == o1.value
                                    )
                                  )}
                                  onChange={(selectedOption) => {
                                    form.setFieldValue(
                                      "divisions",
                                      selectedOption
                                        ? selectedOption.map(
                                            (item) => item.value
                                          )
                                        : []
                                    );
                                  }}
                                />
                              )}
                            </Field>
                            <ErrorMsg name={"divisions"} />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
            <ChangeSaved
              show={edited}
              title={"Super User Edited Successfully"}
            />
            <ErrorPopup
              show={showErrorPopup}
              title={showErrorMsg}
              handleClose={closeErrorPopup}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SuperUserEdit;
export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    maxWidth: "450px",
    height: "40px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",

    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};

export const customStyles2 = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
